/**
 * Figma's `dire-progressbar`: a 4px track whose filled part shows how much of
 * the current period has elapsed. Shared by `SubscriptionStatus` (Abo) and
 * `WatchSimStatus` (Watch SIM), which both bill on the same cycle.
 */
export const SubscriptionProgressBar = ({
  percentage,
}: {
  percentage?: number;
}) => {
  const normalized =
    percentage === undefined ? 0 : Math.min(100, Math.max(0, percentage));

  return (
    <div className="flex h-1 w-full items-start gap-0.5">
      {normalized > 0 && (
        <div
          className="h-full rounded-full bg-surface-accent-blue"
          style={{ width: `${normalized}%` }}
        />
      )}
      {normalized < 100 && (
        <div className="h-full flex-1 rounded-full bg-surface-secondary" />
      )}
    </div>
  );
};
